import { LayoutConfigModel } from '@metronic/core/_base/layout';

export class LayoutConfig {
	public defaults: LayoutConfigModel = {
		'demo': 'quantum',
		// == Base Layout
		'self': {
			'layout': 'fluid', // fluid|boxed
			'body': {
				'background-image': './assets/media/misc/bg-1.jpg',
			},
			'logo': './assets/media/logos/logo_small_quantum.png'
		},
		// == Portlet Plugin
		'portlet': {
			'sticky': {
				'offset': 50
			}
		},
		// == Page Splash Screen loading
		'loader': {
			'enabled': true,
			'type': 'spinner-logo',
			'logo': './assets/media/logos/logo_square.png',
			'message': 'Please wait...'
		},
		// == Colors for javascript
		'colors': {
			'state': {
				'brand': '#1B5671',
				'light': '#ffffff',
				'dark': '#282a3c',
				'primary': '#006FAF',
				'success': '#1dc9b7',
				'info': '#36A3F7',
				'warning': '#ffb822',
				'danger': '#F4516C'
			},
			'base': {
				'label': [
					'#adb1c7',
					'#a7abc3',
					'#575962',
					'#32353f'
				],
				'shape': [
					'#f0f3ff',
					'#d9dffa',
					'#afb4d4',
					'#646c9a'
				]
			}
		},
		'width': 'fixed',
		'header': {
			'self': {
				'fixed': {
					'desktop': {
						'enabled': true,
						'mode': 'topbar'
					},
					'mobile': true
				}
			},
			'search': {
				'display': true
			},
			'menu': {
				'self': {
					'display': true,
					'root-arrow': false
				},
				'desktop': {
					'arrow': true,
					'toggle': 'click',
					'submenu': {
						'skin': 'light',
						'arrow': true
					}
				},
				'mobile': {
					'submenu': {
						'skin': 'dark',
						'accordion': true
					}
				}
			}
		},
		'aside': {
			'self': {
				'skin': 'light',
				'fixed': true,
				'display': true,
				'minimize': {
					'toggle': true,
					'default': false
				}
			},
			'menu': {
				'dropdown': false,
				'scroll': true,
				'submenu': {
					'accordion': true,
					'dropdown': {
						'arrow': true,
						'hover-timeout': 500
					}
				}
			}
		},
		'subheader': {
			'display': true,
			'fixed': false,
			'layout': 'subheader-v2',
			'style': 'transparent',
			'daterangepicker': {
				'display': true
			}
		},
		'footer': {
			'self': {
				'layout': 'extended'
			}
		}
	};

	/**
	 * Good place for getting the remote config
	 */
	public get configs(): LayoutConfigModel {
		return this.defaults;
	}
}
